import { DatePicker as AntdDatePicker, DatePickerProps } from "antd";
import { StyledDatePicker, StyledRangePicker, DatePickerStyle } from "./atom";
import { ConfigProvider } from "antd";
import { PropsWithChildren } from "react";
import i18next from "i18next";
import zhCN from "antd/locale/zh_CN";
import enUS from "antd/locale/en_US";
import "dayjs/locale/zh-cn";
import type { PickerDateProps } from "antd/es/date-picker/generatePicker";

export type RenderbusDatePickerProps = PropsWithChildren<
  PickerDateProps & {
    type?: string;
  }
>;

export function DatePicker({
  className = "",
  type = "range",
  ...props
}: RenderbusDatePickerProps) {
  return (
    <ConfigProvider
      locale={i18next.language === "zh" ? zhCN : enUS}
      theme={{
        token: {
          colorText: "#FFFFFF",
        },
      }}
    >
      {type === "range" && (
        <StyledRangePicker
          className={`renderbus-ui--datePicker range ${className}`}
          {...props}
        />
      )}
      {type === "date" && (
        <StyledDatePicker
          className={`renderbus-ui--datePicker date ${className}`}
          getPopupContainer={(triggerNode) => triggerNode.parentNode}
          {...props}
        />
      )}
      <DatePickerStyle />
    </ConfigProvider>
  );
}
